import React from 'react';
import { View, StyleSheet } from 'react-native';
import { DRNTouchableWrapper } from '@traveloka/district-ui';
import Icon from 'react-native-vector-icons/FontAwesome';

import { UPDATE_FOUND_ACTION_MESSAGE_TYPE } from 'common/constants/serviceWorkerConstants';

import R from 'common/res/R';
import PopupModal from '../PopupModal/PopupModal';

const styles = StyleSheet.create({
  container: {
    marginRight: R.spacing.m,
  },
  notifIcon: {
    alignSelf: 'center',
    opacity: 0.3,
  },
  notifIconActive: {
    opacity: 1,
  },
  notifDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: 'red',
    position: 'absolute',
    top: -3,
    right: 0,
    alignSelf: 'flex-end',
  },
});

class ServiceWorkerNotification extends React.Component {
  state = {
    showNotificationPopup: false,
    updateFound: window.__SW_UPDATE_FOUND__,
  };

  handleShowPopup = () => {
    if (this.state.updateFound) {
      this.setState({ showNotificationPopup: true });
    }
  };

  handleHidePopup = () => {
    this.setState({ showNotificationPopup: false });
  };

  reload = () => {
    window.location.href = '/';
  };

  handleReceiveMessage = event => {
    if (event.origin !== window.location.origin) {
      return;
    }

    try {
      const message = JSON.parse(event.data);
      if (message.type === UPDATE_FOUND_ACTION_MESSAGE_TYPE) {
        window.__SW_UPDATE_FOUND__ = true;
        this.setState({ updateFound: true });
      }
    } catch (e) {
      return;
    }
  };

  componentDidMount() {
    window.addEventListener('message', this.handleReceiveMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleReceiveMessage);
  }

  render() {
    const { showNotificationPopup, updateFound } = this.state;

    const notificationIconStyle = [styles.notifIcon];
    if (updateFound) {
      notificationIconStyle.push(styles.notifIconActive);
    }

    return (
      <React.Fragment>
        <DRNTouchableWrapper onPress={this.handleShowPopup}>
          <View style={styles.container}>
            {updateFound && <View style={styles.notifDot} />}
            <Icon
              style={notificationIconStyle}
              name="bell"
              size={20}
              color={
                updateFound ? R.color.uiLightPrimary : R.color.uiDarkPrimary
              }
            />
          </View>
        </DRNTouchableWrapper>

        <PopupModal
          isVisible={showNotificationPopup}
          onBackdropPress={() => this.handleHidePopup()}
        >
          <PopupModal.Header>Update found</PopupModal.Header>
          <PopupModal.Content>
            Update downloaded. Reload app to install new updates
          </PopupModal.Content>
          <PopupModal.ButtonContainer>
            <PopupModal.Button
              type={PopupModal.Button.type.NEGATIVE}
              text={'NOT NOW'}
              onPress={() => this.handleHidePopup()}
              style={{
                marginRight: 10,
              }}
            />
            <PopupModal.Button
              text={'RELOAD'}
              onPress={() => {
                this.handleHidePopup();
                setInterval(this.reload, 200);
              }}
            />
          </PopupModal.ButtonContainer>
        </PopupModal>
      </React.Fragment>
    );
  }
}

export default ServiceWorkerNotification;
